export default __webpack_public_path__ + "static/media/Weekly_1.34804494.png";